// extracted by mini-css-extract-plugin
module.exports = {"poweredCon":"style_poweredCon__3QhoF","text":"style_text___KlKL","poweredImg":"style_poweredImg__3mAqg"};